













































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { partialInfoModule } from '../store/modules/PartialInfo';
// dto
import { IMunicipal, IMunicipalRegist, IMunicipality, IReturnMunicipal, IMunicipalReq } from '../store/dto/ApplicationForm';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class MunicipalitySelect extends ApiAccessBase {

  private isReadMode: boolean = true;
  private dataCheckList: string[] = [];
  private dataCheckListKibouUmu: string[] = [];

  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/municipal/' + applicationFormModule.GET_APP_TYPE;

  private created() {
    this.screenTitle = '個別情報登録　申請自治体選択';
    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;
    path = path + '/get/' + applicationFormModule.GET_PROCESS_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        this.isReadMode = supervisingModule.IS_MODE_READ;
        // deep copy
        this.dataCheckList = JSON.parse(JSON.stringify(this.formData.localGovernmentKibouUmu));
        //20220726 [個別情報複写機能追加] ishida ADD Start
        this.dataCheckListKibouUmu = JSON.parse(JSON.stringify(this.formData.localGovernmentKibouUmu));
        //20220726 [個別情報複写機能追加] ishida ADD End
      }
    });
  }

  /**
   * 個別情報画面に遷移
   */
  private toPartialInfo(code: string, name: string) {
    applicationFormModule.setMunicipal(code);
    partialInfoModule.setMunicipalName(name);

    if (applicationFormModule.CHECK_TYPE_CONST) {
      router.push({name: UketsukeScreenName.PARTIAL_INFO_CONSTRUCTION});
    } else if (applicationFormModule.CHECK_TYPE_CONSUL) {
      router.push({name: UketsukeScreenName.PARTIAL_INFO_CONSULTING});
    } else {
      router.push({name: UketsukeScreenName.PARTIAL_INFO_CREDENTIALS});
    }
  }

  /**
   * 登録
   */
  private regist() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }

    let path = this.APP_PATH;
    path = path + '/put/' + applicationFormModule.GET_PROCESS_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    // 先頭へジャンプ
    this.hrefElement('municipality-select', -50);
    //20220726 [個別情報複写機能追加] ishida UPD Start
    //this.apiAccess(path, Constants.API_METHOD_POST, false, null).then(
    this.apiAccess(path, Constants.API_METHOD_POST, false, false).then(
    //20220726 [個別情報複写機能追加] ishida UPD End
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          // deep copy
          this.dataCheckList = JSON.parse(JSON.stringify(this.formData.localGovernmentKibouUmu));
          //20220726 [個別情報複写機能追加] ishida ADD Start
          this.dataCheckListKibouUmu = JSON.parse(JSON.stringify(this.formData.localGovernmentKibouUmu));
          //20220726 [個別情報複写機能追加] ishida ADD End
        }
        //20250618 [ステータス変更対応] morimoto ADD Start
        //申請受付ステータスエラーの場合のみ、システムエラー画面に遷移させる。
        if (this.errorMessage.indexOf('statusSystemError') > -1) {
          router.push({name: 'no_auth/SystemError'});
        }
        //20250618 [ステータス変更対応] morimoto ADD End
      },
    );
  }
  //20220726 [個別情報複写機能追加] ishida ADD Start
  /**
   * 前回複写
   */
  private lastCopy() {
    if (!this.isReadMode) {
      //確認メッセージ
      if (!confirm(Message.I0025)) {
        return;
      }
    }
    // form成形
    this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }

    let path = this.APP_PATH;
    path = path + '/lastCopy/' + applicationFormModule.GET_PROCESS_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    // 先頭へジャンプ
    this.hrefElement('municipality-select', -50);
    this.apiAccess(path, Constants.API_METHOD_POST, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {

          // deep copy
          this.dataCheckList = JSON.parse(JSON.stringify(this.formData.localGovernmentKibouUmu));
          this.dataCheckListKibouUmu = JSON.parse(JSON.stringify(this.formData.localGovernmentKibouUmu));
        }
        //20250618 [ステータス変更対応] morimoto ADD Start
        //申請受付ステータスエラーの場合のみ、システムエラー画面に遷移させる。
        if (this.errorMessage.indexOf('statusSystemError') > -1) {
          router.push({name: 'no_auth/SystemError'});
        }
        //20250618 [ステータス変更対応] morimoto ADD End
      },
    );
  }
  //20220726 [個別情報複写機能追加] ishida ADD End

  //20220726 [個別情報複写機能追加] ishida ADD Start
  //リクエストデータ希望有無の編集
  private checkBoxValue(meisaiIndex : any) {
    if (this.formData.localGovernmentKibouUmu[meisaiIndex] === '1') {
      this.formData.localGovernmentKibouUmu[meisaiIndex] = null;
    } else {
      this.formData.localGovernmentKibouUmu[meisaiIndex] = '1';
    }
  }
  //20220726 [個別情報複写機能追加] ishida ADD End
  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    if (!this.isReadMode) {
      if (!confirm(Message.I0014)) {
        return;
      }
    }
    // 前画面に戻る
    router.push({name: UketsukeScreenName.APPLICATION_FORM});
  }
}
